<script setup lang="ts">
import type { IDashboardWidgetProps, TWidgetEmits } from '@tenorlab/vue-dashboard'
import { DashboardWidgetBase, useWidgetEmits } from '@tenorlab/vue-dashboard'

const props = defineProps<IDashboardWidgetProps>()
const emits = defineEmits<TWidgetEmits>()
const emitHandlers = useWidgetEmits(emits)

type TItem = {
  key: string
  colorClasses: string
  abbr: string
  name: string
  subtitle: string
}

const items: TItem[] = [
  {
    key: 'tl',
    colorClasses: 'bg-primary content-primary',
    abbr: 'TL',
    name: 'Tenorlab PRO',
    subtitle: '23 Members',
  },
  {
    key: 're',
    colorClasses: 'bg-warning content-warning',
    abbr: 'RE',
    name: 'React',
    subtitle: '19 Members',
  },
  {
    key: 'vu',
    colorClasses: 'bg-info content-info',
    abbr: 'VU',
    name: 'Vue',
    subtitle: '15 Members',
  },
  {
    key: 'nu',
    colorClasses: 'bg-success content-success',
    abbr: 'NU',
    name: 'Nuxt',
    subtitle: '12 Members',
  },
  {
    key: 'wt',
    colorClasses: 'bg-danger content-danger',
    abbr: 'TW',
    name: 'Tailwind',
    subtitle: '8 Members',
  },
]
</script>

<template>
  <DashboardWidgetBase v-bind="props" direction="row" v-on="emitHandlers">
    <div>
      <ul role="list" class="mt-3 grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-5">
        <li v-for="item in items" :key="item.key" class="col-span-1 flex rounded-md">
          <div
            :class="`flex w-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium ${item.colorClasses}`"
          >
            {{ item.abbr }}
          </div>
          <div
            class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-body-invert"
          >
            <div class="flex-1 truncate px-4 py-2 text-sm">
              <a href="#" class="font-medium text-primary hover:text-primary">
                {{ item.name }}
              </a>
              <p class="">{{ item.subtitle }}</p>
            </div>
            <button
              type="button"
              class="inline-flex size-8 items-center justify-center rounded-full cursor-pointer text-primary opacity-70 hover:opacity-90 hover:outline-2 hover:outline-primary"
            >
              <span class="sr-only">Open options</span>
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5">
                <path
                  d="M10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM10 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM11.5 15.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
                />
              </svg>
            </button>
          </div>
        </li>
      </ul>
    </div>
  </DashboardWidgetBase>
</template>
